function tabs () {
     // Tabs
    const tabs = document.querySelectorAll('.tabheader__item'),
    tabsContent = document.querySelectorAll('.tabcontent'),
    tabsParent = document.querySelector('.tabheader__items');

    function hideTabContent() {
    tabsContent.forEach((item) => {
        item.classList.add('hide')
        item.classList.remove('show', 'fade')
        })
    tabs.forEach((item) => {
        item.classList.remove('tabheader__item_active')
        })  
    }

    function showTabContent(idx = 0) {
        tabsContent[idx].classList.add('show', 'fade')
        tabsContent[idx].classList.remove('hide')
        tabs[idx].classList.add('tabheader__item_active')
    }
    hideTabContent()
    showTabContent()

    tabsParent.addEventListener('click', (event) => {
    const target = event.target
    if (target && target.classList.contains('tabheader__item')) {
        tabs.forEach((item, idx) => {
            if (target === item) {
                hideTabContent()
                showTabContent(idx)
            }
        })
    }
    })
}
module.exports = tabs;